const COOKIE_PREFERENCE_KEY = 'siteCookiePreferenceState';

const TRACKING_COOKIE_NAMES = [
    // Google Analytics / Ads
    '_ga', '_gid', '_gat', '_gac_preserved', '_gcl_au', '_gcl_aw', '_gcl_dc', 'IDE',
    // Clarity
    '_clck', '_clsk', 'CLID', 'ANONCHK', 'MR', 'MUID', 'SM',
    // Yotpo - Inspect your site for actual Yotpo cookie names
    // e.g., 'yotpo_pixel_V2', 'yotpo_cart_product_ids'
    // Facebook Pixel
    '_fbp', '_fbc',
    // Add any other specific tracking cookies here
];

const TRACKING_COOKIE_PREFIXES = [
    '_ga_', // For some Google cookies like _ga_XXXXXXX
    '_uet', // Microsoft UET (Bing Ads)
];

function getCookieDomainScope() {
    const hostname = window.location.hostname;
    const liveSiteRoot = "tp-link.com"; // Your main website's root domain

    if (hostname.endsWith('.tp-link.com')) {
        // For Shopify previews, cookies are scoped to the specific preview hostname.
        // An empty string for domain attribute makes the cookie host-only.
        return "";
    } else if (hostname.endsWith('.' + liveSiteRoot) || hostname === liveSiteRoot) {
        // For the live site (e.g., us.store.tp-link.com, store.tp-link.com, tp-link.com)
        // Scope to .tp-link.com to cover all subdomains.
        return "." + liveSiteRoot;
    }
    return "";
}

function setRootDomainCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    const domainScope = getCookieDomainScope();
    const domainAttribute = domainScope ? "; domain=" + domainScope : "";
    document.cookie = name + "=" + (value || "") + expires + "; path=/" + domainAttribute + "; SameSite=Lax";
}


function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
            const value = c.substring(nameEQ.length, c.length);
            return value;
        }
    }
    return null;
}

function eraseRootDomainCookie(name) {
    const domainScope = getCookieDomainScope();
    const currentHostname = window.location.hostname;
    const paths = ['/'];

    const domainsToDeleteOn = [domainScope];
    if (domainScope !== "" && `.${currentHostname}` !== domainScope && currentHostname !== domainScope) {
        domainsToDeleteOn.push(currentHostname); 
    }
    domainsToDeleteOn.push(""); // Host-only

    for (const d of [...new Set(domainsToDeleteOn.filter(Boolean))]) { // Unique, non-empty domains
        for (const p of paths) {
            document.cookie = `${name}=; Max-Age=-99999999; path=${p}; domain=${d}; SameSite=Lax`;
            document.cookie = `${name}=; Max-Age=-99999999; path=${p}; domain=${d}`; // Without SameSite for broader compatibility if needed
        }
    }
    // Fallback for host-only cookies or cookies set without explicit domain
    for (const p of paths) {
      document.cookie = `${name}=; Max-Age=-99999999; path=${p}; SameSite=Lax`;
      document.cookie = `${name}=; Max-Age=-99999999; path=${p}`;
    }
}

function manageCookies(isOptingOutExplicitly = false) {
    // This function is called to enforce the consent state.
    // If isOptingOutExplicitly is true, or if the preference cookie is 'disabled',
    // then proceed to remove tracking cookies.

    const shouldDisableTrackers = isOptingOutExplicitly || (getCookie(COOKIE_PREFERENCE_KEY) === 'disabled');

    if (shouldDisableTrackers) {
        if (isOptingOutExplicitly) { // Ensure preference is set if this is an explicit opt-out action
            setRootDomainCookie(COOKIE_PREFERENCE_KEY, 'disabled', 365);
        }

        const cookies = document.cookie.split(";");
        const calculatedDomainScope = getCookieDomainScope();
        const currentHostname = window.location.hostname;

        for (const cookieStr of cookies) {
            const eqPos = cookieStr.indexOf("=");
            let name = eqPos > -1 ? cookieStr.substr(0, eqPos).trim() : cookieStr.trim();

            if (name === "" || name === COOKIE_PREFERENCE_KEY) {
                continue;
            }

            let isTrackingCookie = TRACKING_COOKIE_NAMES.includes(name) ||
                                   TRACKING_COOKIE_PREFIXES.some(prefix => name.startsWith(prefix));

            if (isTrackingCookie) {
                eraseRootDomainCookie(name);
            }
        }
    }
}

function shouldLoadTrackers() {
    return getCookie(COOKIE_PREFERENCE_KEY) !== 'disabled';
}

function updateGoogleConsentState() {
    if (typeof gtag !== 'function') {
        return;
    }
    const consentGranted = shouldLoadTrackers();
    const newGoogleState = consentGranted ? 'granted' : 'denied';
    gtag('consent', 'update', {
        'ad_storage': newGoogleState,
        'ad_user_data': newGoogleState,
        'ad_personalization': newGoogleState,
        'analytics_storage': newGoogleState
    });
    if(consentGranted) {
        localStorage.setItem('google_ad_storage_consent', newGoogleState);
        localStorage.setItem('google_ad_user_data_consent', newGoogleState);
        localStorage.setItem('google_ad_personalization_consent', newGoogleState);
        localStorage.setItem('google_analytics_storage_consent', newGoogleState);
    } else {
        localStorage.removeItem('google_ad_storage_consent');
        localStorage.removeItem('google_ad_user_data_consent');
        localStorage.removeItem('google_ad_personalization_consent');
        localStorage.removeItem('google_analytics_storage_consent');
    }
}

function manageKlaviyoTrackingCookie() {
    const domainScope = getCookieDomainScope();
    const domainAttribute = domainScope ? "; domain=" + domainScope : "";

    if (!shouldLoadTrackers()) { // User has opted OUT
        document.cookie = "__kla_off=true; path=/; max-age=31536000" + domainAttribute + "; SameSite=Lax";
    } else { // User has opted IN
        document.cookie = "__kla_off=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT" + domainAttribute + "; SameSite=Lax";
    }
}

function loadAndConfigGtagIfConsented() {
    const ADS_GOOGLE_TAG_ID = 'AW-16894562532';
    const gtagScriptId = 'gtag-main-script-' + ADS_GOOGLE_TAG_ID;

    if (document.getElementById(gtagScriptId)) return;

    const script = document.createElement('script');
    script.id = gtagScriptId;
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + ADS_GOOGLE_TAG_ID;

    script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        const currentPageLocation = (typeof init !== 'undefined' && init.context?.window?.location?.href)
                                    ? init.context.window.location.href
                                    : window.location.href;
        gtag('set', { page_location: currentPageLocation });
        gtag('js', new Date());
        gtag('config', ADS_GOOGLE_TAG_ID, { 'allow_enhanced_conversions': true });

        if (typeof analytics !== 'undefined' && typeof analytics.subscribe === 'function') {
            analytics.subscribe('page_viewed', (event) => {
                gtag('event', 'page_view', {
                    send_to: ADS_GOOGLE_TAG_ID,
                    page_location: event.context?.window.location.href || currentPageLocation
                });
            });

            const _setUPD = (checkout) => {
                if (!checkout) return;
                const upd = {};
                if (checkout.email) upd.email = checkout.email.trim().toLowerCase();
                const phoneFromCheckout = checkout.phone?.trim();
                const phoneFromBilling = checkout.billingAddress?.phone?.trim();
                if (phoneFromCheckout || phoneFromBilling) {
                     upd.phone_number = phoneFromCheckout || phoneFromBilling;
                }
                const address = checkout.billingAddress;
                if (address) {
                    upd.address = {
                        first_name: address.firstName, last_name: address.lastName,
                        country: address.countryCode, postal_code: address.zip,
                        street: address.address1, city: address.city,
                        region: address.province || address.provinceCode,
                    };
                }
                if (Object.keys(upd).length > 0) gtag('set', 'user_data', upd);
            };

            analytics.subscribe('checkout_completed', (event) => {
                const eventPageLocation = event.context?.window.location.href || currentPageLocation;
                gtag('event', 'page_view', {
                    send_to: ADS_GOOGLE_TAG_ID, page_location: eventPageLocation
                });
                const checkout = event.data.checkout;
                if (checkout && checkout.order) {
                    _setUPD(checkout);
                    gtag('event', 'conversion', {
                        send_to: ADS_GOOGLE_TAG_ID + '/n-5NCPbkxqMaEOSh-vc-',
                        value: checkout.totalPrice.amount,
                        currency: checkout.currencyCode,
                        transaction_id: checkout.order.id,
                    });
                }
            });
        }
    };
    script.onerror = () => console.error('Failed to load gtag.js for ' + ADS_GOOGLE_TAG_ID);
    document.head.appendChild(script);
}

document.addEventListener('DOMContentLoaded', () => {
    const openBtn = document.getElementById('openCookiePopupBtn');
    const closeBtn = document.getElementById('closeCookiePopupBtn');
    const modalOverlay = document.getElementById('cookieModalOverlay');
    const acceptAllBtn = document.getElementById('acceptAllBtn');
    const saveChoicesBtn = document.getElementById('saveChoicesBtn');
    const optOutBtn = document.getElementById('optOutBtn');
    const analyticsToggle = document.getElementById('yourNewAnalyticsToggleId');

    function setShopifyConsentAndReload(allowAnalytics) {
        if (typeof closeModal === 'function') closeModal();
        
        if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
            Shopify.customerPrivacy.setTrackingConsent({ analytics: allowAnalytics }, (error) => {
                if (error) console.error('[Shopify Consent] Error setting consent:', error);
                window.location.reload();
            });
        } else {
            console.warn('[Shopify Consent] API not available for setTrackingConsent.');
            window.location.reload();
        }
    }

function initializeAnalyticsToggleState() {
    const analyticsToggle = document.getElementById('yourNewAnalyticsToggleId');
    if (!analyticsToggle) return;
    const isOptedOut = getCookie(COOKIE_PREFERENCE_KEY) === 'disabled'; // CORRECTED
    analyticsToggle.checked = !isOptedOut;

    analyticsToggle.disabled = false;
}

    function openModal() {
        if (modalOverlay) {
            initializeAnalyticsToggleState();
            modalOverlay.classList.add('active');
        }
    }

    function closeModal() {
        if (modalOverlay) modalOverlay.classList.remove('active');
    }

    function executeOptOutProcedure() {
        if (analyticsToggle) analyticsToggle.checked = false;
        manageCookies(true); // This sets localStorage 'siteCookiePreference' to 'disabled'
        updateGoogleConsentState(); // Reads from localStorage
        manageKlaviyoTrackingCookie(); // Reads from localStorage
        setShopifyConsentAndReload(false); // analytics false
    }

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('open_privacy_popup') && urlParams.get('open_privacy_popup') === 'true') {
        openModal();
    }

    if (openBtn) openBtn.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (modalOverlay) modalOverlay.addEventListener('click', (e) => { if (e.target === modalOverlay) closeModal(); });

    if (acceptAllBtn) {
        acceptAllBtn.addEventListener('click', () => {
            if (analyticsToggle) analyticsToggle.checked = true;
            eraseRootDomainCookie(COOKIE_PREFERENCE_KEY); // Remove 'disabled' preference
            // updateGoogleConsentState, manageKlaviyoTrackingCookie will be called again after reload or rely on initial load logic.
            // The key is that shouldLoadTrackers() will now be true.
            // For immediate effect before reload:
            updateGoogleConsentState(); 
            manageKlaviyoTrackingCookie();
            setShopifyConsentAndReload(true);
        });
    }

    if (saveChoicesBtn) {
        saveChoicesBtn.addEventListener('click', () => {
            const analyticsAllowed = analyticsToggle ? analyticsToggle.checked : false;
            if (analyticsAllowed) {
                eraseRootDomainCookie(COOKIE_PREFERENCE_KEY);
                // For immediate effect before reload:
                updateGoogleConsentState();
                manageKlaviyoTrackingCookie();
                setShopifyConsentAndReload(true);
            } else {
                executeOptOutProcedure();
            }
        });
    }

    if (optOutBtn) {
        optOutBtn.addEventListener('click', executeOptOutProcedure);
    }

    // --- Initial Execution Logic ---
    if (getCookie(COOKIE_PREFERENCE_KEY) === 'disabled') {
        manageCookies(); 
    }
    updateGoogleConsentState(); 
    manageKlaviyoTrackingCookie(); 

    if (shouldLoadTrackers()) {
        if (typeof loadAndConfigGtagIfConsented === 'function') {
            loadAndConfigGtagIfConsented();
        } else {
            console.error("[CookieConsent] loadAndConfigGtagIfConsented function is not defined!");
        }

        // Clarity
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "pzp4oyqalr");

        // Yotpo
        const yotpoLoaderSrc = 'https://cdn-widgetsrepository.yotpo.com/v1/loader/5lY15RD4fDnmNxh1nBWLeNqQRb02rvPSvYQqe0nT?languageCode=en';
        const yotpoScriptId = 'yotpo-loader-script';
        if (!document.getElementById(yotpoScriptId)) {
            const yotpoScriptTag = document.createElement('script');
            yotpoScriptTag.id = yotpoScriptId;
            yotpoScriptTag.type = 'text/javascript';
            yotpoScriptTag.src = yotpoLoaderSrc;
            yotpoScriptTag.async = true;
            document.head.appendChild(yotpoScriptTag);
        }
    }
});

// Separate script block for overriding Shopify's "Manage preferences" button
(function() {
    const shopifyButtonIdToOverride = 'shopify-pc__banner__btn-manage-prefs';
    const customModalTriggerButtonId = 'openCookiePopupBtn';

    const checkFrequency = 250;
    const maxWaitTime = 5000;
    let timeElapsed = 0;
    let overrideListenerAttached = false;

    const intervalTimer = setInterval(() => {
        if (overrideListenerAttached) {
            clearInterval(intervalTimer);
            return;
        }
        const shopifyButtonElement = document.getElementById(shopifyButtonIdToOverride);
        if (shopifyButtonElement) {
            const customModalTrigger = document.getElementById(customModalTriggerButtonId);
            if (customModalTrigger) {
                shopifyButtonElement.addEventListener('click', function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    customModalTrigger.click();
                }, true);
                overrideListenerAttached = true;
                clearInterval(intervalTimer);
            }
        }
        timeElapsed += checkFrequency;
        if (timeElapsed >= maxWaitTime && !overrideListenerAttached) {
            clearInterval(intervalTimer);
        }
    }, checkFrequency);
})();